import state from './moduleFeaturesState'
import actions from './moduleFeaturesActions'
import getters from './moduleFeaturesGetters'
import mutations from './moduleFeaturesMutations'

export default {
    namespaced: true,
    isRegistered: false,

    state: state,
    actions: actions,
    getters: getters,
    mutations: mutations
}
